class Responsive {

  constructor() {
    this.ww = window.outerWidth;
    this.wh = window.outerHeight;
    this.currentViewport = this.getCurrentViewport();
  }

  static getCurrentViewport() {

    const ww = window.outerWidth;
    const viewports = {
      xl: 1440,
      lg: 1140,
      md: 800,
      sm: 600,
      xs: 300
    }

    for (const vw_name in viewports) {
      if (viewports[vw_name] <= ww)
        return vw_name;
    }

    return "xs";
  }
}

export default Responsive



// WEBPACK FOOTER //
// ./src/scripts/Responsive.js